import axios from 'axios'
import qs from 'qs'
import errorHandler from './error-handler'

export default {
  async search (query, jobBoardId, page, size) {
    return axios.get(`/api/companiesToJobBoard/job-board/${jobBoardId}/jobs?${qs.stringify(query)}&page=${page}&size=${size}&status=published`)
      .then(r => r.data).catch(errorHandler)
  },
  async getWidgetJobs (query, jobBoardId, page, size) {
    return axios.get(`/api/companiesToJobBoard/job-board/${jobBoardId}/jobs?${qs.stringify(query)}&page=${page}&size=${size}&status=published`)
      .then(r => r.data).catch(errorHandler)
  },
  async getWidgetCompanies (query, jobBoardId, page, size) {
    return axios.get(`/api/companiesToJobBoard/job-board/${jobBoardId}?${qs.stringify(query)}&page=${page}&size=${size}`)
      .then(r => r.data).catch(errorHandler)
  },
  async getWidgetTalents (jobBoardId, page, size, data) {
    return axios.post(`/api/job_board/${jobBoardId}/talent?page=${page}&size=${size}`, data).then(r => r.data).catch(errorHandler)
  },
  async submitJobForm ({firstName, lastName, email, file, captcha, jobId}) {
    const formData = new FormData()
    formData.append('firstName', firstName)
    formData.append('lastName', lastName)
    formData.append('email', email)
    formData.append('file', file)
    formData.append('captcha', captcha)
    formData.append('jobId', jobId)
    return axios.post(`/api/applications/widget/apply`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(r => r.data).catch(errorHandler)
  },
  async widgetLogin (token) {
    return axios.post(`/api/applications/widget/login`, {token}).then(r => r.data).catch(errorHandler)
  },
  async resendEmail (data) {
    return axios.post(`/api/applications/widget/resend-email`, data).then(r => r.data).catch(errorHandler)
  },
  async checkProfileStatus () {
    return axios.get(`/api/applications/widget/status`).then(r => r.data).catch(errorHandler)
  },
  async getWidgetStyles (jobBoardId) {
    return axios.get(`/api/job_board/${jobBoardId}`).then(r => r.data).catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/widget.js